var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbUpStylized = function SvgThumbUpStylized(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6F2F0",
    d: "M.533 7.048C1.474 4.796 4.06 2.263 8.8 5.255s6.05 5.724 5.109 7.976c-.942 2.253-5.053 2.89-8.61 1.403C1.744 13.148-.408 9.301.534 7.048Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M6.095 7.752 7.904 4.86a1.35 1.35 0 0 1 2.102-.24c.254.253.396.597.396.955v1.738h2.886a1.376 1.376 0 0 1 1.326 1.002 1.4 1.4 0 0 1 .037.59l-.61 3.97a1.384 1.384 0 0 1-1.367 1.172H7.617c-.315 0-.627-.074-.91-.215l-.451-.226H4.552a.884.884 0 0 1-.885-.885V8.637a.884.884 0 0 1 .885-.885zm.777 5.044.281.14c.145.072.304.11.465.11h5.056a.38.38 0 0 0 .378-.324l.61-3.97a.37.37 0 0 0-.087-.307.38.38 0 0 0-.289-.133H9.902a.5.5 0 0 1-.5-.5V5.574a.352.352 0 0 0-.65-.186l-1.88 3.008zM4.667 8.752v3.853h1.205V8.752z",
    clipRule: "evenodd"
  })));
};
export default SvgThumbUpStylized;